import {TabsReducer} from "../../../../common/tabs/tabs.reducer";
import {IDS} from "../adm-categorisation-action-id.constants";
export const admCatCapabilitiesTabs = {
    [IDS.app_administration_categorisation_capabilities]: Object.assign(TabsReducer(), {
        tabs: [
            {
                state: IDS.app_administration_categorisation_capabilities_grid,
                title: 'Site Capabilities',
                visible: true,
                disabled: false,
                loading: false,
            },
            {
                state: IDS.app_administration_categorisation_capabilities_details,
                title: 'Details',
                visible: false,
                disabled: false,
                loading: false
            },
        ]
    }),
}